<div class="card-remove-wrapper">
  <div class="img-align">
    <div class="left">
      <img src="assets/icon/Group 566.svg" alt="card-remove" />
    </div>
    <div class="right" *ngIf="data.message != 'Card Added Successfully' && data.message != 'Balance transferred successfully'">
      <img src="assets/icon/clear.svg"
        class="close-icon" alt="close" (click)="close();crossBtnGA()"/>
    </div>
  </div>
  <div class="card-remove-wrapper2">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="text-center" *ngIf="data?.message != 'Card deleted successfully.'">
            {{data?.message}}
          </h2>
          <h2 class="text-center" *ngIf="data?.message == 'Card deleted successfully.'">
            Your Starbucks Card {{cardHolderName}} (*{{cardNO | slice:-4}}) has been removed.
          </h2>
          <p class="text-center" *ngIf="data?.message == 'Card deleted successfully.'">
            You can easily add a new Starbucks Physical card or buy a digital card from the app!
          </p>
        </div>
        <div class="col-12 text-center mt-4">
          <button *ngIf="data?.buttonName !== 'Add New Card'" type="button" class="custom-btn btn-md-rounded btn-black"
          (click)="close()">
            {{data?.buttonName}}
          </button>
          <button *ngIf="data?.buttonName == 'Add New Card'" type="button" class="custom-btn btn-md-rounded btn-black"
          (click)="addNewCard()">
            {{data?.buttonName}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 text-right">
    <img src="assets/icon/Group45.svg" alt="card-remove" />
  </div>
</div>
